<template>
  <div>
    <b-row class="mb-3 text-center">
      <b-col lg="12">
        <h2 class="font-size-16">Dziękujemy za udział w egzaminie</h2>
      </b-col>
      <b-col lg="12 pb-lg-3">
        <strong class="color-red font-size-20">
          Przykro nam, ale nie udało Ci się zaliczyć testu
        </strong>
      </b-col>
      <b-col lg="12">
        <b-row>
          <div class="bg-white rounded-circle topImage p-3 pt-4 pl-4 m-auto">
            <b-img class="m-auto" :src="styles.course_failed" fluid></b-img>
          </div>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="2" class="ml-auto">
            <b-row class="text-center color-green"
              ><div class="m-auto font-weight-bold color-green font-size-28">
                {{ examResults.correct }}
              </div></b-row
            >
            <b-row class="text-center"
              ><div class="m-auto">Odpowiedzi poprawne</div></b-row
            >
          </b-col>
          <b-col lg="2" class="mr-auto">
            <b-row class="text-center"
              ><div class="m-auto font-weight-bold color-red font-size-28">
                {{ examResults.invalid }}
              </div></b-row
            >
            <b-row> <div class="m-auto">Odpowiedzi niepoprawne</div></b-row>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="my-lg-auto mb-3">
            <b-card
              bg-variant="light"
              class="m-auto d-inline-block"
              style="max-width: 600px"
              no-body
            >
              <b-card-text class="d-flex flex-row p-3">
                Zapoznaj się ponownie z tematyką szkolenia, aby poprawić swój
                wynik.
              </b-card-text>
            </b-card>
            <b-button
              class="
                btn
                mr-0
                ml-lg-4
                my-lg-auto
                mt-3
                font-size-16
                p-2
                px-3
                color-white
                min-wd-lg-160
              "
              v-on:click="$emit('showCourse')"
            >
              <b-icon-box-arrow-left /> Wróć do Kursu</b-button
            >
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="my-lg-auto mb-3">
            <b-card
              bg-variant="light"
              class="m-auto d-inline-block"
              style="max-width: 600px"
              no-body
            >
              <b-card-text class="d-flex flex-row p-3">
                Spróbuj spróbuj swoich sił ponownie przystępując jeszcze raz do
                testu:
              </b-card-text>
            </b-card>
            <b-button
              v-on:click="clearParticipant"
              class="
                btn
                mr-0
                ml-lg-4
                my-lg-auto
                mt-3
                font-size-16
                p-2
                px-3
                color-white
                min-wd-lg-160
              "
            >
              <b-icon-arrow-repeat /> Powtórz test</b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CourseExamFailed',
  data() {
    return {};
  },
  props: {
    styles: {},
    examResults: {},
    participantName: {},
    participantId: {},
  },
  computed: {
    ...mapGetters({
      licence: 'auth/userLicence',
    }),
  },
  created() {
    window.dataLayer.push({
      event: 'btnTestWynikNegatywny',
      user_id: this.participantId,
      license_id: this.licence,
    });
  },
  methods: {
    clearParticipant() {
      this.$emit('clearParticipant');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .topImage {
    width: 140px;
    height: 140px;
  }
}
</style>
